import { render, staticRenderFns } from "./register-personalise-account.vue?vue&type=template&id=68169b93&"
import script from "./register-personalise-account.vue?vue&type=script&lang=js&"
export * from "./register-personalise-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports